import React from 'react'
import { Button, Container } from 'react-bootstrap'
import Header from '../Header'
import "./PaymentSuccessPage.css"
import { Link } from 'react-router-dom'

function PaymentSuccessPage() {
    return (
        <>

            <Header />
            <Container className='payment-page-container'>
                {/* <div className='d-flex flex-column justify-content-center align-items-center'> */}
                {/* <i className="fa-solid fa-circle-check" style={{ color: "#63E6BE" }}></i> */}
                <img src={"/images/check-circle.1 1.png"} />
                <h1 className='payment-success-title'>Payment Successful</h1>
                <p className='payment-detail'>Thank you for ordering. <br />Your payment is successfully completed.</p>
                <Link to="/">
                    <Button className="btn btn-warning logout-button mt-4 mb-4">
                        Go to Home Page
                    </Button>
                </Link>
                {/* </div> */}
            </Container>
        </>
    )
}

export default PaymentSuccessPage